import adjustWorkTimes from './rules/adjustWorkTimes.js';
import postedSchedules from './rules/postedSchedules.js';
import liveSchedules from './rules/liveSchedules.js';
import mySchedule from './rules/mySchedule.js';
import sameResource from './rules/sameResource.js';
import assignments from './rules/assignments.js';
import editMode from './rules/editMode.js';
import addTour from './rules/addTour.js';
import changeDayType from './rules/changeDayType.js';
import isApprover from './rules/isApprover.js';
import editTour from './rules/editTour.js';
import addDayTypeRequest from './rules/addDayTypeRequest.js';
import editDayTypeRequest from './rules/editDayTypeRequest.js';
import removeDayTypeRequest from './rules/removeDayTypeRequest.js';
import changeAssignmentsResource from './rules/changeAssignmentsResource.js';
import changeAbsencesResource from './rules/changeAbsencesResource.js';
import addAssignment from './rules/addAssignment.js';
import addAssignmentViewPrices from './rules/addAssignmentViewPrices.js';
import addAssignmentViewActivityType from './rules/addAssignmentViewActivityType.js';
import addAssignmentEditActivityType from './rules/addAssignmentEditActivityType.js';
import addAssignmentViewSalaryLevel from './rules/addAssignmentViewSalaryLevel.js';
import addAssignmentViewAssignmentStatus from './rules/addAssignmentViewAssignmentStatus.js';
import addAssignmentEditAssignmentStatus from './rules/addAssignmentEditAssignmentStatus.js';
import addAssignmentViewDescription from './rules/addAssignmentViewDescription.js';
import addAssignmentEditDescription from './rules/addAssignmentEditDescription.js';
import deleteAssignment from './rules/deleteAssignment.js';
import deleteRequest from './rules/deleteRequest.js';
import viewActivityType from './rules/viewActivityType.js';
import viewTourSalaryLevel from './rules/viewTourSalaryLevel.js';
import viewTourSalaryLevelUpgrade from './rules/viewTourSalaryLevelUpgrade.js';
import viewAssignmentSalaryLevelAndUpgrade from './rules/viewAssignmentSalaryLevelAndUpgrade.js';
import approveTours from './rules/approveTours.js';
import approveJobElements from './rules/approveJobElements.js';
import submitApprovals from './rules/submitApprovals.js';
import resourceInfo from './rules/resourceInfo.js';
import resourceInfoSSO from './rules/resourceInfoSSO.js';
import approvals from './rules/approvals.js';
import viewCalendar from './rules/viewCalendar.js';
import editStatus from './rules/editStatus.js';
import viewStatus from './rules/viewStatus.js';
import previousPostings from './rules/previousPostings.js';

const authLogic = {
  adjustWorkTimes,
  postedSchedules: postedSchedules,
  previousPostings,
  liveSchedules: liveSchedules,
  mySchedule,
  sameResource, // can probably delete
  assignments: assignments,
  editMode,
  addTour,
  changeDayType,
  isApprover,
  editTour,
  addDayTypeRequest,
  editDayTypeRequest,
  removeDayTypeRequest,
  changeAssignmentsResource,
  changeAbsencesResource,
  addAssignment,
  addAssignmentViewPrices,
  addAssignmentViewActivityType,
  addAssignmentEditActivityType,
  addAssignmentViewSalaryLevel,
  addAssignmentViewAssignmentStatus,
  addAssignmentEditAssignmentStatus,
  addAssignmentViewDescription,
  addAssignmentEditDescription,
  deleteAssignment,
  deleteRequest,
  viewActivityType,
  viewTourSalaryLevel,
  viewTourSalaryLevelUpgrade,
  viewAssignmentSalaryLevelAndUpgrade,
  approveTours,
  approveJobElements,
  submitApprovals,
  resourceInfo,
  resourceInfoSSO,
  approvals,
  viewCalendar,
  editStatus,
  viewStatus
};


export default authLogic;
